import { Component, OnInit, NgModule } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationService } from './notification.service';
import { DxPopupModule, DxButtonModule, DxToastModule } from 'devextreme-angular';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})

export class NotificationComponent implements OnInit {

  notification: Notification;
  private _subscription: Subscription;
  toaster: Toaster;
  title: string = 'Error';
  showPopup: boolean = false;
  showTechDetails: boolean = false;
  showSessionExpireNotificationPopup: boolean = false;

  constructor(private notificationService: NotificationService,
    private router : Router) { }

  ngOnInit() {
    this._subscription = this.notificationService.getObservable().subscribe(notification => this.addNotification(notification));
  }

  onbtnClick() {
    this.showTechDetails = true;
  }

  private addNotification(notification: Notification) {
    this.notification = notification;
    if (this.notification) {
      if (this.notification.type == NotificationTypes.Success) {
        this.toaster = new Toaster('success', 5000, true, this.notification.message);
      } else if (this.notification.type == NotificationTypes.Error || this.notification.type == NotificationTypes.Warning) {
        this.title = this.notification.type == NotificationTypes.Warning ? 'Warning' : 'Error';
        this.showPopup = true;
      } else if (this.notification.type == NotificationTypes.SessionWarning) {
        this.showSessionExpireNotificationPopup = true;
      }
    }
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  onPopupShowing(e: any) {
    if (e.component && e.component.topToolbar()) {
      if (this.notification.type == NotificationTypes.Warning) {
        e.component.topToolbar().addClass('warning-title');
      } else {
        e.component.topToolbar().addClass('error-title');
      }
    }
  }

  refreshWindow(e) {
    this.notification = null;
    this.showSessionExpireNotificationPopup = false;
    this.router.navigate(['/home']);
  }

  onPopUpClosing(e: any) {
    this.notification = null;
    this.showPopup = false;
    this.showTechDetails = false;
  }

}

@NgModule({
  imports: [CommonModule, DxPopupModule, DxButtonModule, DxToastModule],
  declarations: [NotificationComponent],
  exports: [NotificationComponent]
})
export class NotificationModule { }

export class Notification {
  constructor(
    public type: string,
    public message: string,
    public technicalDetails: any,
  ) { }
}

export class Toaster {
  constructor(
    public toastType: string,
    public displayTime: number,
    public isToastVisible: boolean,
    public toastMessage: string
  ) { }
}

export enum NotificationTypes {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  SessionWarning = 'sessionwarning'
}